




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';
import BirthdayCoinSettings from '@/components/organisms/Offers/DataPresentation/BirthdayCoinSettings.vue';
import FinePrintIcon from '@/components/icons/FinePrint.vue';

import flagKeys from '@/constants/flagKeys';
import { IOfferEdit } from '@/models/offer';

@Component({
  components: {
    TextField,
    FormHeader,
    BirthdayCoinSettings,
    FinePrintIcon
  }
})
export default class FinePrint extends Vue {
  @Prop() errors!: string[];
  @Prop() offer?: IOfferEdit;

  data = { restrictions: this.offer ? this.offer.restrictions : '' };

  get tPrefix() {
    return 'offers.form';
  }

  get characterLimitationIsActivated() {
    return !this.flags.includes(flagKeys.disableCharacterLimitationOnOffer);
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get restrictionFieldIsActivated() {
    return this.flags.includes(flagKeys.offerRestrictionField);
  }

  @Watch('data', { deep: true })
  changedData(data: any) {
    this.$emit('input', data);
  }
}
